
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import { _ as _objectSpread, a as _slicedToArray } from './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import PendoLoadingIndicator from './pendo-loading-indicator.js';
import isNumber from 'lodash/isNumber';
import { s as setStyles, a as setAttributes } from './table-auto-height-mixin.js';
import 'popper.js';
import uuid from 'uuid';
import 'vue-resize';
import clamp from 'lodash/clamp';
import { P as PickerPopover } from './picker-popover-mixin.js';
import isString from 'lodash/isString';
import isArrayLikeObject from 'lodash/isArrayLikeObject';
import isDate from 'lodash/isDate';
import isPlainObject from 'lodash/isPlainObject';

var script = {
  name: 'Shortcuts',
  props: {
    options: {
      type: Array,
      default: null
    }
  },
  methods: {
    handleOptionClick(option) {
      this.$emit('select', option);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-date-picker__default-ranges"
  }, [_c('ul', {
    attrs: {
      "role": "listbox"
    }
  }, _vm._l(_vm.options, function (option, index) {
    return _c('li', {
      key: index,
      attrs: {
        "title": option.label,
        "role": "option"
      }
    }, [_c('span', {
      class: {
        'is-disabled': option.disabled,
        'is-selected': option.selected
      },
      on: {
        "click": function ($event) {
          return _vm.handleOptionClick(option);
        }
      }
    }, [_vm._t("shortcut", [_vm._v("\n                    " + _vm._s(option.label) + "\n                ")], {
      "shortcut": option
    })], 2)]);
  }), 0)]);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "shortcuts.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var Shortcuts = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

var script$1 = {
  name: 'CalendarMonth',
  props: {
    month: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      isHovering: false,
      isFocused: false
    };
  },

  methods: {
    handleMonthClick() {
      if (this.month.disabled) {
        return;
      }

      this.$emit('click', this.month.key);
    },

    handleMonthMouseEnter() {
      if (this.month.disabled) {
        return;
      }

      this.isHovering = true;
    },

    handleMonthMouseLeave() {
      this.isHovering = false;
    }

  }
};

const __vue_script__$1 = script$1;

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-date-picker__month",
    class: {
      'is-hovering': _vm.isHovering,
      'is-disabled': _vm.month.disabled,
      'is-selected': _vm.month.selected,
      'is-current': _vm.month.current
    },
    on: {
      "click": _vm.handleMonthClick,
      "mouseenter": _vm.handleMonthMouseEnter,
      "mouseleave": _vm.handleMonthMouseLeave
    }
  }, [_c('div', {
    staticClass: "pendo-date-picker__month-highlight-current"
  }), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "pendo-date-picker__month-content"
  }, [_vm._v("\n        " + _vm._s(_vm.month.label) + "\n    ")])]);
};

var __vue_staticRenderFns__$1 = [];
const __vue_inject_styles__$1 = undefined;
const __vue_scope_id__$1 = undefined;
const __vue_is_functional_template__$1 = false;

function __vue_normalize__$1(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "calendar-month.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var CalendarMonth = __vue_normalize__$1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1);

var script$2 = {
  name: 'CalendarYear',
  props: {
    year: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      isHovering: false,
      isFocused: false
    };
  },

  methods: {
    handleYearClick() {
      if (this.year.disabled) {
        return;
      }

      this.$emit('click', this.year.key);
    },

    handleYearMouseEnter() {
      if (this.year.disabled) {
        return;
      }

      this.isHovering = true;
    },

    handleYearMouseLeave() {
      this.isHovering = false;
    }

  }
};

const __vue_script__$2 = script$2;

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-date-picker__year",
    class: {
      'is-hovering': _vm.isHovering,
      'is-disabled': _vm.year.disabled,
      'is-selected': _vm.year.selected,
      'is-current': _vm.year.current
    },
    on: {
      "click": _vm.handleYearClick,
      "mouseenter": _vm.handleYearMouseEnter,
      "mouseleave": _vm.handleYearMouseLeave
    }
  }, [_c('div', {
    staticClass: "pendo-date-picker__year-highlight-current"
  }), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "pendo-date-picker__year-content"
  }, [_vm._v("\n        " + _vm._s(_vm.year.label) + "\n    ")])]);
};

var __vue_staticRenderFns__$2 = [];
const __vue_inject_styles__$2 = undefined;
const __vue_scope_id__$2 = undefined;
const __vue_is_functional_template__$2 = false;

function __vue_normalize__$2(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "calendar-year.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var CalendarYear = __vue_normalize__$2({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2);

var script$3 = {
  name: 'CalendarDay',
  inject: ['state'],
  props: {
    day: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      isHovering: false,
      isFocused: false
    };
  },

  computed: {
    isDragging() {
      return !!this.state.dragValue;
    },

    isHidden() {
      return !this.day.inMonth;
    },

    isDisabled() {
      return !!this.day.disabled;
    },

    isSelected() {
      if (!this.day.attribute) {
        return false;
      }

      if (this.day.attribute.key === 'select' && this.day.attribute.targetDate.isDate) {
        return this.day.attribute.targetDate.dateTime === this.day.dateTime;
      }

      if (this.onStart || this.onEnd) {
        return !this.state.dragValue;
      }

      return false;
    },

    onStart() {
      if (!this.day.attribute) {
        return false;
      }

      return this.day.attribute.targetDate.startTime === this.day.dateTime;
    },

    onEnd() {
      if (!this.day.attribute) {
        return false;
      }

      return this.day.attribute.targetDate.endTime === this.day.dateTime;
    },

    onStartAndEnd() {
      return this.onStart && this.onEnd;
    },

    dayEvent() {
      return _objectSpread({}, this.day, {
        el: this.$refs.content
      });
    },

    inRange() {
      if (!this.day.attribute) {
        return false;
      }

      if (!['select', 'drag'].includes(this.day.attribute.key)) {
        return false;
      }

      return !this.isDisabled && !this.isDateOrComplex && !this.onStartAndEnd;
    },

    isDateOrComplex() {
      if (!this.day.attribute) {
        return false;
      }

      const _this$day$attribute$t = this.day.attribute.targetDate,
            isDate = _this$day$attribute$t.isDate,
            isComplex = _this$day$attribute$t.isComplex;
      return isDate || isComplex;
    },

    isDragStart() {
      if (this.state.type !== 'range' || !this.state.dragValue || !this.day.attribute) {
        return false;
      }

      return this.state.dragValue.start.getTime() === this.day.dateTime;
    }

  },
  methods: {
    getDayEvent(origEvent) {
      return _objectSpread({}, this.dayEvent, {
        event: origEvent
      });
    },

    handleDayClick($event) {
      if (this.isDisabled) {
        return;
      }

      this.$emit('dayclick', this.getDayEvent($event));
    },

    handleDayMouseEnter($event) {
      if (this.isDisabled) {
        return;
      }

      this.isHovering = true;
      this.$emit('daymouseenter', this.getDayEvent($event));
    },

    handleDayMouseLeave($event) {
      this.isHovering = false;
      this.$emit('daymouseleave', this.getDayEvent($event));
    },

    handleDayFocus($event) {
      this.isFocused = true;
      this.$emit('dayfocusin', this.getDayEvent($event));
    },

    handleDayBlur($event) {
      this.isFocused = false;
      this.$emit('dayfocusout', this.getDayEvent($event));
    }

  }
};

const __vue_script__$3 = script$3;

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-date-picker__day",
    class: [_vm.day.classes, {
      'is-hidden': _vm.isHidden,
      'is-disabled': _vm.isDisabled,
      'is-hovering': _vm.isHovering,
      'is-range-start': _vm.onStart && _vm.isDragging,
      'is-range-end': _vm.onEnd && _vm.isDragging,
      'is-selected': _vm.isSelected,
      'is-drag-start': _vm.isDragStart
    }],
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.handleDayClick,
      "mouseenter": _vm.handleDayMouseEnter,
      "mouseleave": _vm.handleDayMouseLeave,
      "focusin": _vm.handleDayFocus,
      "focusout": _vm.handleDayBlur
    }
  }, [_c('div', {
    staticClass: "pendo-date-picker__day-highlight-current"
  }), _vm._v(" "), _c('div', {
    staticClass: "pendo-date-picker__day-highlight-base",
    class: {
      'is-range-start': _vm.onStart,
      'is-range-middle': _vm.inRange,
      'is-range-end': _vm.onEnd
    }
  }), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "pendo-date-picker__day-content"
  }, [_vm._v("\n        " + _vm._s(_vm.day.label) + "\n    ")])]);
};

var __vue_staticRenderFns__$3 = [];
const __vue_inject_styles__$3 = undefined;
const __vue_scope_id__$3 = undefined;
const __vue_is_functional_template__$3 = false;

function __vue_normalize__$3(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "calendar-day.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var CalendarDay = __vue_normalize__$3({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3);

const isObject = value => Object.prototype.toString.call(value).slice(8, -1) === 'Object';

function pageIsValid(page) {
  return !!(page && page.month && page.year);
}

function pageIsBeforePage(page, comparePage) {
  if (!pageIsValid(page) || !pageIsValid(comparePage)) {
    return false;
  }

  if (page.year === comparePage.year) {
    return page.month < comparePage.month;
  }

  return page.year < comparePage.year;
}

function pageIsAfterPage(page, comparePage) {
  if (!pageIsValid(page) || !pageIsValid(comparePage)) {
    return false;
  }

  if (page.year === comparePage.year) {
    return page.month > comparePage.month;
  }

  return page.year > comparePage.year;
}

function pageIsBetweenPages(page, fromPage, toPage) {
  if (!page) {
    return false;
  }

  return !pageIsBeforePage(page, fromPage) && !pageIsAfterPage(page, toPage);
}

function pageForDate(date) {
  if (!date) {
    return null;
  }

  return {
    month: date.getMonth() + 1,
    year: date.getFullYear()
  };
}

function addPages({
  month,
  year
}, count) {
  const incr = count > 0 ? 1 : -1;

  for (let i = 0; i < Math.abs(count); i++) {
    month += incr;

    if (month > 12) {
      month = 1;
      year++;
    } else if (month < 1) {
      month = 12;
      year--;
    }
  }

  return {
    month,
    year
  };
}

function pageForThisMonth() {
  return pageForDate(new Date());
}

function getMaxPage(...args) {
  return args.reduce((prev, curr) => {
    if (!prev) {
      return curr;
    }

    if (!curr) {
      return prev;
    }

    return pageIsAfterPage(curr, prev) ? curr : prev;
  });
}

function datesAreEqual(a, b) {
  const aIsDate = isDate(a);
  const bIsDate = isDate(b);

  if (!aIsDate && !bIsDate) {
    return true;
  }

  if (aIsDate !== bIsDate) {
    return false;
  }

  return a.getTime() === b.getTime();
}

function arrayHasItems(array) {
  return isArrayLikeObject(array) && array.length;
}

function mixinOptionalProps(source, target, props) {
  const assigned = [];
  props.forEach(prop => {
    const name = prop.name || prop.toString();
    const mixin = prop.mixin,
          validate = prop.validate;

    if (Object.prototype.hasOwnProperty.call(source, name)) {
      const value = validate ? validate(source[name]) : source[name];
      target[name] = mixin && isPlainObject(value) ? _objectSpread({}, mixin, value) : value;
      assigned.push(name);
    }
  });
  return {
    target,
    assigned: assigned.length ? assigned : null
  };
}

var script$4 = {
  name: 'CalendarPane',
  components: {
    CalendarDay,
    CalendarMonth,
    CalendarYear,
    PendoIcon
  },
  inject: ['state'],
  props: {
    page: {
      type: Object,
      required: true
    },
    canMove: {
      type: Function,
      default: () => true
    },
    minPage: {
      type: Object,
      default: null
    },
    maxPage: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      mode: 'day',
      yearIndex: 0,
      yearGroupIndex: 0
    };
  },

  computed: {
    canMovePrev() {
      if (!this.minPage || !pageIsValid(this.minPage)) {
        return true;
      }

      return {
        day: pageIsAfterPage(this.page, this.minPage),
        month: this.yearIndex > this.minPage.year,
        year: this.firstYear - 1 > this.minPage.year
      }[this.mode];
    },

    canMoveNext() {
      if (!this.maxPage || !pageIsValid(this.maxPage)) {
        return true;
      }

      return {
        day: pageIsBeforePage(this.page, this.maxPage),
        month: this.yearIndex < this.maxPage.year,
        year: this.lastYear + 1 < this.maxPage.year
      }[this.mode];
    },

    locale() {
      return this.state.locale;
    },

    masks() {
      return this.state.locale.masks;
    },

    count() {
      return this.state.visibleColumnCount;
    },

    isTitleInteractive() {
      return !(this.count > 1);
    },

    isHeaderRightButtonVisible() {
      return this.count > 1 ? this.page.position === 1 : true;
    },

    isHeaderLeftButtonVisible() {
      return this.count > 1 ? this.page.position === 0 : true;
    },

    weekdays() {
      return this.state.locale.getWeekdayDates().map(date => this.state.locale.format(date, this.masks.weekdays));
    },

    days() {
      return this.page.days;
    },

    month() {
      if (this.page) {
        return this.page.month || 0;
      }

      return 0;
    },

    year() {
      if (this.page) {
        return this.page.year || 0;
      }

      return 0;
    },

    title() {
      return {
        day: this.page.title,
        month: this.yearIndex,
        year: `${this.firstYear} - ${this.lastYear}`
      }[this.mode];
    },

    months() {
      const _pageForDate = pageForDate(new Date()),
            currentMonth = _pageForDate.month,
            currentYear = _pageForDate.year;

      return this.state.locale.getMonthDates().map(date => this.state.locale.format(date, this.masks.months)).map((label, i) => {
        const month = i + 1;
        return {
          label,
          selected: month === this.month && this.yearIndex === this.year,
          current: month === currentMonth && this.yearIndex === currentYear,
          disabled: !this.canMove({
            month,
            year: this.yearIndex
          }),
          key: i + 1
        };
      });
    },

    years() {
      const _pageForDate2 = pageForDate(new Date()),
            currentYear = _pageForDate2.year;

      const startYear = this.yearGroupIndex * 12;
      const endYear = startYear + 12;
      const minYear = this.minPage ? this.minPage.year : null;
      const maxYear = this.maxPage ? this.maxPage.year : null;
      const items = [];

      for (let year = startYear; year < endYear; year += 1) {
        items.push({
          year,
          label: year,
          key: year,
          selected: year === this.year,
          current: year === currentYear,
          disabled: minYear && minYear > year || maxYear && maxYear < year
        });
      }

      return items;
    },

    firstYear() {
      return [].concat(this.years.map(i => i.year)).shift();
    },

    lastYear() {
      return [].concat(this.years.map(i => i.year)).pop();
    }

  },
  watch: {
    year() {
      this.yearIndex = this.year;
    },

    yearIndex(val) {
      this.yearGroupIndex = Math.floor(val / 12);
    }

  },

  created() {
    this.yearIndex = this.year;
  },

  methods: {
    move(page) {
      this.$emit('update:page', page);
    },

    toggleMode() {
      if (this.count > 1) {
        return;
      }

      const nextMode = {
        day: 'month',
        month: 'year',
        year: 'month'
      }[this.mode];
      this.mode = nextMode;
    },

    monthClick(month) {
      this.move({
        month,
        year: this.yearIndex
      });
      this.mode = 'day';
    },

    yearClick(year) {
      this.yearIndex = year;
      this.mode = 'month';
    },

    movePrev() {
      if (this.mode === 'day') {
        return this.$emit('move-prev');
      }

      if (this.mode === 'month') {
        this.yearIndex--;
      }

      this.yearGroupIndex--;
    },

    moveNext() {
      if (this.mode === 'day') {
        return this.$emit('move-next');
      }

      if (this.mode === 'month') {
        this.yearIndex++;
      }

      this.yearGroupIndex++;
    }

  }
};

const __vue_script__$4 = script$4;

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "pane",
    staticClass: "pendo-date-picker__pane"
  }, [_c('div', {
    staticClass: "pendo-date-picker__header"
  }, [_vm.isHeaderLeftButtonVisible ? _c('div', {
    staticClass: "pendo-date-picker__header-arrow pendo-date-picker__header-arrow--left",
    class: {
      'is-disabled': !_vm.canMovePrev
    },
    on: {
      "click": _vm.movePrev
    }
  }, [_c('pendo-icon', {
    attrs: {
      "type": "chevron-left",
      "size": "16"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pendo-date-picker__header-title",
    class: {
      'is-interactive': _vm.isTitleInteractive
    },
    on: {
      "click": _vm.toggleMode
    }
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), _vm.isHeaderRightButtonVisible ? _c('div', {
    staticClass: "pendo-date-picker__header-arrow pendo-date-picker__header-arrow--right",
    class: {
      'is-disabled': !_vm.canMoveNext
    },
    on: {
      "click": _vm.moveNext
    }
  }, [_c('pendo-icon', {
    attrs: {
      "type": "chevron-right",
      "size": "16"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _vm.mode === 'day' ? _c('div', {
    staticClass: "pendo-date-picker__days"
  }, [_vm._l(_vm.weekdays, function (label, index) {
    return _c('div', {
      key: index,
      staticClass: "pendo-date-picker__weekday"
    }, [_vm._v("\n            " + _vm._s(label) + "\n        ")]);
  }), _vm._v(" "), _vm._l(_vm.days, function (day) {
    return _c('calendar-day', _vm._g({
      key: day.id,
      ref: "days",
      refInFor: true,
      attrs: {
        "day": day
      }
    }, _vm.$listeners));
  })], 2) : _vm._e(), _vm._v(" "), _vm.mode === 'month' ? _c('div', {
    staticClass: "pendo-date-picker__months"
  }, _vm._l(_vm.months, function (mo) {
    return _c('calendar-month', {
      key: mo.key,
      attrs: {
        "month": mo
      },
      on: {
        "click": _vm.monthClick
      }
    });
  }), 1) : _vm._e(), _vm._v(" "), _vm.mode === 'year' ? _c('div', {
    staticClass: "pendo-date-picker__years"
  }, _vm._l(_vm.years, function (yr) {
    return _c('calendar-year', {
      key: yr.key,
      attrs: {
        "year": yr
      },
      on: {
        "click": _vm.yearClick
      }
    });
  }), 1) : _vm._e()]);
};

var __vue_staticRenderFns__$4 = [];
const __vue_inject_styles__$4 = undefined;
const __vue_scope_id__$4 = undefined;
const __vue_is_functional_template__$4 = false;

function __vue_normalize__$4(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "calendar-pane.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var CalendarPane = __vue_normalize__$4({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4);

const token = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
const twoDigits = /\d\d?/;
const threeDigits = /\d{3}/;
const fourDigits = /\d{4}/;
const word = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
const literal = /\[([^]*?)\]/gm;

const noop = () => {};

function monthUpdate(arrName) {
  return (d, v, i18n) => {
    const index = i18n[arrName].indexOf(v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());

    if (~index) {
      d.month = index;
    }
  };
}

function pad(val, len) {
  val = String(val);
  len = len || 2;

  while (val.length < len) {
    val = `0${val}`;
  }

  return val;
}

const formatFlags = {
  D(dateObj) {
    return dateObj.getDate();
  },

  DD(dateObj) {
    return pad(dateObj.getDate());
  },

  Do(dateObj, i18n) {
    return i18n.DoFn(dateObj.getDate());
  },

  d(dateObj) {
    return dateObj.getDay();
  },

  dd(dateObj) {
    return pad(dateObj.getDay());
  },

  W(dateObj, i18n) {
    return i18n.dayNamesNarrow[dateObj.getDay()];
  },

  WW(dateObj, i18n) {
    return i18n.dayNamesShorter[dateObj.getDay()];
  },

  WWW(dateObj, i18n) {
    return i18n.dayNamesShort[dateObj.getDay()];
  },

  WWWW(dateObj, i18n) {
    return i18n.dayNames[dateObj.getDay()];
  },

  M(dateObj) {
    return dateObj.getMonth() + 1;
  },

  MM(dateObj) {
    return pad(dateObj.getMonth() + 1);
  },

  MMM(dateObj, i18n) {
    return i18n.monthNamesShort[dateObj.getMonth()];
  },

  MMMM(dateObj, i18n) {
    return i18n.monthNames[dateObj.getMonth()];
  },

  YY(dateObj) {
    return String(dateObj.getFullYear()).substr(2);
  },

  YYYY(dateObj) {
    return pad(dateObj.getFullYear(), 4);
  },

  h(dateObj) {
    return dateObj.getHours() % 12 || 12;
  },

  hh(dateObj) {
    return pad(dateObj.getHours() % 12 || 12);
  },

  H(dateObj) {
    return dateObj.getHours();
  },

  HH(dateObj) {
    return pad(dateObj.getHours());
  },

  m(dateObj) {
    return dateObj.getMinutes();
  },

  mm(dateObj) {
    return pad(dateObj.getMinutes());
  },

  s(dateObj) {
    return dateObj.getSeconds();
  },

  ss(dateObj) {
    return pad(dateObj.getSeconds());
  },

  S(dateObj) {
    return Math.round(dateObj.getMilliseconds() / 100);
  },

  SS(dateObj) {
    return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
  },

  SSS(dateObj) {
    return pad(dateObj.getMilliseconds(), 3);
  },

  a(dateObj, i18n) {
    return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
  },

  A(dateObj, i18n) {
    return dateObj.getHours() < 12 ? i18n.amPm[0].toUpperCase() : i18n.amPm[1].toUpperCase();
  },

  ZZ(dateObj) {
    const o = dateObj.getTimezoneOffset();
    return (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4);
  }

};
const parseFlags = {
  D: [twoDigits, (d, v) => {
    d.day = v;
  }],
  Do: [new RegExp(twoDigits.source + word.source), (d, v) => {
    d.day = parseInt(v, 10);
  }],
  d: [twoDigits, noop],
  W: [word, noop],
  M: [twoDigits, (d, v) => {
    d.month = v - 1;
  }],
  MMM: [word, monthUpdate('monthNamesShort')],
  MMMM: [word, monthUpdate('monthNames')],
  YY: [twoDigits, (d, v) => {
    const da = new Date();
    const cent = +da.getFullYear().toString().substr(0, 2);
    d.year = `${v > 68 ? cent - 1 : cent}${v}`;
  }],
  YYYY: [fourDigits, (d, v) => {
    d.year = v;
  }],
  S: [/\d/, (d, v) => {
    d.millisecond = v * 100;
  }],
  SS: [/\d{2}/, (d, v) => {
    d.millisecond = v * 10;
  }],
  SSS: [threeDigits, (d, v) => {
    d.millisecond = v;
  }],
  h: [twoDigits, (d, v) => {
    d.hour = v;
  }],
  m: [twoDigits, (d, v) => {
    d.minute = v;
  }],
  s: [twoDigits, (d, v) => {
    d.second = v;
  }],
  a: [word, (d, v, i18n) => {
    const val = v.toLowerCase();

    if (val === i18n.amPm[0]) {
      d.isPm = false;
    } else if (val === i18n.amPm[1]) {
      d.isPm = true;
    }
  }],
  ZZ: [/([\+\-]\d\d:?\d\d|Z)/, (d, v) => {
    if (v === 'Z') {
      v = '+00:00';
    }

    const parts = `${v}`.match(/([+-]|\d\d)/gi);

    if (parts) {
      const minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
      d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
    }
  }]
};
parseFlags.DD = parseFlags.D;
parseFlags.dd = parseFlags.d;
parseFlags.WWWW = parseFlags.WWW = parseFlags.WW = parseFlags.W;
parseFlags.MM = parseFlags.M;
parseFlags.mm = parseFlags.m;
parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
parseFlags.ss = parseFlags.s;
parseFlags.A = parseFlags.a;
const format = (dateObj, mask, locale) => {
  if (isNumber) {
    dateObj = new Date(dateObj);
  }

  if (!isDate(dateObj)) {
    throw new Error('Invalid Date in fecha.format');
  }

  mask = locale.masks[mask] || mask;
  const literals = [];
  mask = mask.replace(literal, ($0, $1) => {
    literals.push($1);
    return '??';
  });
  mask = mask.replace(token, $0 => $0 in formatFlags ? formatFlags[$0](dateObj, locale) : $0.slice(1, $0.length - 1));
  return mask.replace(/\?\?/g, () => literals.shift());
};

const parseString = (dateStr, mask, locale) => {
  if (typeof mask !== 'string') {
    throw new Error('Invalid mask in fecha.parse');
  }

  mask = locale.masks[mask] || mask;

  if (dateStr.length > 1000) {
    return false;
  }

  let isValid = true;
  const dateInfo = {};
  mask.replace(token, $0 => {
    if (parseFlags[$0]) {
      const info = parseFlags[$0];
      const index = dateStr.search(info[0]);

      if (!~index) {
        isValid = false;
      } else {
        dateStr.replace(info[0], result => {
          info[1](dateInfo, result, locale);
          dateStr = dateStr.substr(index + result.length);
          return result;
        });
      }
    }

    return parseFlags[$0] ? '' : $0.slice(1, $0.length - 1);
  });

  if (!isValid) {
    return false;
  }

  const today = new Date();

  if (dateInfo.isPm === true && dateInfo.hour != null && +dateInfo.hour !== 12) {
    dateInfo.hour = +dateInfo.hour + 12;
  } else if (dateInfo.isPm === false && +dateInfo.hour === 12) {
    dateInfo.hour = 0;
  }

  let date;

  if (dateInfo.timezoneOffset != null) {
    dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
    date = new Date(Date.UTC(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0));
  } else {
    date = new Date(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0);
  }

  return date;
};

const parse = (dateStr, mask, locale) => {
  const masks = isArrayLikeObject(mask) && mask || [isString(mask) && mask || 'YYYY-MM-DD'];
  return masks.map(m => parseString(dateStr, m, locale)).find(d => d) || new Date(dateStr);
};

const daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
class Locale {
  constructor({
    id,
    firstDayOfWeek,
    masks
  }) {
    this.id = id;
    this.firstDayOfWeek = clamp(firstDayOfWeek, 1, 7);
    this.masks = masks;
    this.dayNames = this.getDayNames('long');
    this.dayNamesShort = this.getDayNames('short');
    this.dayNamesShorter = this.dayNamesShort.map(s => s.substring(0, 2));
    this.dayNamesNarrow = this.getDayNames('narrow');
    this.monthNames = this.getMonthNames('long');
    this.monthNamesShort = this.getMonthNames('short');
    this.monthData = {};
    this.getMonthComps = this.getMonthComps.bind(this);
    this.parse = this.parse.bind(this);
    this.format = this.format.bind(this);
    this.toDate = this.toDate.bind(this);
  }

  parse(dateStr, mask) {
    return parse(dateStr, mask || this.masks.L, this);
  }

  format(date, mask) {
    return format(date, mask || this.masks.L, this);
  }

  toDate(dt, mask) {
    if (isDate(dt)) {
      return new Date(dt.getTime());
    }

    if (isNumber(dt)) {
      return new Date(dt);
    }

    if (isString(dt)) {
      return this.parse(dt, mask);
    }

    if (isPlainObject(dt)) {
      const date = new Date();
      return new Date(dt.year || date.getFullYear(), dt.month || date.getMonth(), dt.day || date.getDate());
    }

    return dt;
  }

  getMonthDates(year = 2000) {
    const dates = [];

    for (let i = 0; i < 12; i++) {
      dates.push(new Date(year, i, 15));
    }

    return dates;
  }

  getMonthNames(length) {
    const dtf = new Intl.DateTimeFormat(this.id, {
      month: length,
      timeZone: 'UTC'
    });
    return this.getMonthDates().map(date => dtf.format(date));
  }

  getWeekdayDates({
    year = 2000,
    utc = false,
    firstDayOfWeek = this.firstDayOfWeek
  } = {}) {
    const dates = [];

    for (let i = 1, j = 0; j < 7; i++) {
      const date = utc ? new Date(Date.UTC(year, 0, i)) : new Date(year, 0, i);
      const day = utc ? date.getUTCDay() : date.getDay();

      if (day === firstDayOfWeek - 1 || j > 0) {
        dates.push(date);
        j++;
      }
    }

    return dates;
  }

  getDayNames(length) {
    const dtf = new Intl.DateTimeFormat(this.id, {
      weekday: length,
      timeZone: 'UTC'
    });
    return this.getWeekdayDates({
      firstDayOfWeek: 1,
      utc: true
    }).map(date => dtf.format(date));
  }

  getMonthComps(month, year) {
    const key = `${month}-${year}`;
    let comps = this.monthData[key];

    if (!comps) {
      const inLeapYear = year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
      const firstWeekday = new Date(year, month - 1, 1).getDay() + 1;
      const days = month === 2 && inLeapYear ? 29 : daysInMonths[month - 1];
      const weeks = Math.ceil((days + Math.abs(firstWeekday - this.firstDayOfWeek)) / 7);
      comps = {
        firstDayOfWeek: this.firstDayOfWeek,
        inLeapYear,
        firstWeekday,
        days,
        weeks,
        month,
        year
      };
      this.monthData[key] = comps;
    }

    return comps;
  }

  getThisMonthComps() {
    const date = new Date();
    return this.getMonthComps(date.getMonth() + 1, date.getFullYear());
  }

  getPrevMonthComps(month, year) {
    if (month === 1) {
      return this.getMonthComps(12, year - 1);
    }

    return this.getMonthComps(month - 1, year);
  }

  getNextMonthComps(month, year) {
    if (month === 12) {
      return this.getMonthComps(1, year + 1);
    }

    return this.getMonthComps(month + 1, year);
  }

  getDayFromDate(date) {
    if (!date) {
      return null;
    }

    const month = date.getMonth() + 1;
    const year = date.getUTCFullYear();
    const comps = this.getMonthComps(month, year);
    const day = date.getDate();
    const dayFromEnd = comps.days - day + 1;
    const weekday = date.getDay() + 1;
    const weekdayOrdinal = Math.floor((day - 1) / 7 + 1);
    const weekdayOrdinalFromEnd = Math.floor((comps.days - day) / 7 + 1);
    const week = Math.ceil((day + Math.abs(comps.firstWeekday - comps.firstDayOfWeek)) / 7);
    const weekFromEnd = comps.weeks - week + 1;
    return {
      day,
      dayFromEnd,
      weekday,
      weekdayOrdinal,
      weekdayOrdinalFromEnd,
      week,
      weekFromEnd,
      month,
      year,
      date,
      dateTime: date.getTime()
    };
  }

  getCalendarDays(page) {
    const days = [];
    const monthComps = page.monthComps,
          prevMonthComps = page.prevMonthComps,
          nextMonthComps = page.nextMonthComps;
    const firstDayOfWeek = monthComps.firstDayOfWeek,
          firstWeekday = monthComps.firstWeekday;
    const prevMonthDaysToShow = firstWeekday + (firstWeekday < firstDayOfWeek ? 7 : 0) - firstDayOfWeek;
    let prevMonth = true;
    let thisMonth = false;
    let nextMonth = false;
    let day = prevMonthComps.days - prevMonthDaysToShow + 1;
    let dayFromEnd = prevMonthComps.days - day + 1;
    let weekdayOrdinal = Math.floor((day - 1) / 7 + 1);
    let weekdayOrdinalFromEnd = 1;
    let week = prevMonthComps.weeks;
    let weekFromEnd = 1;
    let month = prevMonthComps.month,
        year = prevMonthComps.year;
    const today = new Date();
    const todayDay = today.getDate();
    const todayMonth = today.getMonth() + 1;
    const todayYear = today.getFullYear();

    for (let wk = 1; wk <= 6; wk++) {
      for (let i = 1, weekday = firstDayOfWeek; i <= 7; i++, weekday += weekday === 7 ? -6 : 1) {
        if (prevMonth && weekday === firstWeekday) {
          day = 1;
          dayFromEnd = monthComps.days;
          weekdayOrdinal = Math.floor((day - 1) / 7 + 1);
          weekdayOrdinalFromEnd = Math.floor((monthComps.days - day) / 7 + 1);
          week = 1;
          weekFromEnd = monthComps.weeks;
          month = monthComps.month;
          year = monthComps.year;
          prevMonth = false;
          thisMonth = true;
        }

        const date = new Date(year, month - 1, day);
        const weekdayPosition = i;
        const weekdayPositionFromEnd = 7 - i;
        const isToday = day === todayDay && month === todayMonth && year === todayYear;
        const isFirstDay = thisMonth && day === 1;
        const isLastDay = thisMonth && day === monthComps.days;
        const onTop = wk === 1;
        const onBottom = wk === 6;
        const onLeft = i === 1;
        const onRight = i === 7;
        days.push({
          id: `${month}-${day}`,
          label: day.toString(),
          day,
          dayFromEnd,
          weekday,
          weekdayPosition,
          weekdayPositionFromEnd,
          weekdayOrdinal,
          weekdayOrdinalFromEnd,
          week,
          weekFromEnd,
          month,
          year,
          date,
          dateTime: date.getTime(),
          isToday,
          isFirstDay,
          isLastDay,
          inMonth: thisMonth,
          inPrevMonth: prevMonth,
          inNextMonth: nextMonth,
          onTop,
          onBottom,
          onLeft,
          onRight,
          classes: [`day-${day}`, `day-from-end-${dayFromEnd}`, `weekday-${weekday}`, `weekday-position-${weekdayPosition}`, `weekday-ordinal-${weekdayOrdinal}`, `weekday-ordinal-from-end-${weekdayOrdinalFromEnd}`, `week-${week}`, `week-from-end-${weekFromEnd}`, {
            'is-today': isToday,
            'is-first-day': isFirstDay,
            'is-last-day': isLastDay,
            'in-month': thisMonth,
            'in-prev-month': prevMonth,
            'in-next-month': nextMonth,
            'on-top': onTop,
            'on-bottom': onBottom,
            'on-left': onLeft,
            'on-right': onRight
          }],
          attribute: null
        });

        if (thisMonth && isLastDay) {
          thisMonth = false;
          nextMonth = true;
          day = 1;
          dayFromEnd = nextMonthComps.days;
          weekdayOrdinal = 1;
          weekdayOrdinalFromEnd = Math.floor((nextMonthComps.days - day) / 7 + 1);
          week = 1;
          weekFromEnd = nextMonthComps.weeks;
          month = nextMonthComps.month;
          year = nextMonthComps.year;
        } else {
          day++;
          dayFromEnd--;
          weekdayOrdinal = Math.floor((day - 1) / 7 + 1);
          weekdayOrdinalFromEnd = Math.floor((monthComps.days - day) / 7 + 1);
        }
      }

      week++;
      weekFromEnd--;
    }

    if (days[days.length - 7].inNextMonth) {
      days.length -= 7;
    }

    return days;
  }

}

const millisecondsPerDay = 24 * 60 * 60 * 1000;
function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
class DateInfo {
  constructor(config, {
    locale = new Locale()
  } = {}) {
    this.isDateInfo = true;
    this.isRange = isObject(config) || typeof config === 'function';
    this.isDate = !this.isRange;
    this.locale = locale;
    this.mask = locale.masks.data;
    this.getMonthComps = locale.getMonthComps;
    this.firstDayOfWeek = locale.firstDayOfWeek;

    if (this.isDate) {
      this.type = 'date';
      let date = this.toDate(config);
      date = isDate(date) ? date : new Date();
      date.setHours(0, 0, 0, 0);
      this.date = date;
      this.dateTime = date.getTime();
    }

    if (this.isRange) {
      this.type = 'range';

      if (typeof config === 'function') {
        this.on = {
          and: config
        };
      } else {
        let start = this.toDate(config.start);
        let end = this.toDate(config.end);

        if (start && end && start > end) {
          const temp = start;
          start = end;
          end = temp;
        } else if (start && config.span >= 1) {
          end = addDays(start, config.span - 1);
        }

        if (start) {
          if (!isDate(start)) {
            start = null;
          } else {
            start.setHours(0, 0, 0, 0);
          }
        }

        if (end) {
          if (!isDate(end)) {
            end = null;
          } else {
            end.setHours(0, 0, 0, 0);
          }
        }

        this.start = start;
        this.end = end;
        this.startTime = start && start.getTime();
        this.endTime = end && end.getTime();

        if (start && end) {
          this.daySpan = this.diffInDays(start, end);
          this.weekSpan = this.diffInWeeks(start, end);
          this.monthSpan = this.diffInMonths(start, end);
          this.yearSpan = this.diffInYears(start, end);
        }

        const andOpt = mixinOptionalProps(config, {}, DateInfo.patternProps);

        if (andOpt.assigned) {
          this.on = {
            and: andOpt.target
          };
        }

        if (config.on) {
          const or = (isArrayLikeObject(config.on) ? config.on : [config.on]).map(op => {
            if (typeof op === 'function') {
              return op;
            }

            const opt = mixinOptionalProps(op, {}, DateInfo.patternProps);
            return opt.assigned ? opt.target : null;
          }).filter(op => op);

          if (or.length) {
            this.on = _objectSpread({}, this.on, {
              or
            });
          }
        }
      }

      this.isComplex = !!this.on;
    }
  }

  toDate(date) {
    const mask = this.locale.masks.data;
    return this.locale.toDate(date, mask);
  }

  findShallowIntersectingRange(date1, date2) {
    const thisRange = date1.toRange();
    const otherRange = date2.toRange();
    let start = null;
    let end = null;

    if (thisRange.start) {
      if (!otherRange.start) {
        start = thisRange.start;
      } else {
        start = thisRange.start < otherRange.start ? thisRange.start : otherRange.start;
      }
    } else if (otherRange.start) {
      start = otherRange.start;
    }

    if (thisRange.end && (!start || thisRange.end >= start)) {
      end = thisRange.end;
    }

    if (otherRange.end && (!start || otherRange.end >= start)) {
      if (!end || otherRange.end < end) {
        end = otherRange.end;
      }
    }

    return {
      start,
      end
    };
  }

  startOfWeek(date) {
    const day = date.getDay() + 1;
    const daysToAdd = day >= this.firstDayOfWeek ? this.firstDayOfWeek - day : -(7 - (this.firstDayOfWeek - day));
    return addDays(date, daysToAdd);
  }

  diffInDays(d1, d2) {
    return Math.round((d2 - d1) / millisecondsPerDay);
  }

  diffInWeeks(d1, d2) {
    return this.diffInDays(this.startOfWeek(d1), this.startOfWeek(d2));
  }

  diffInYears(d1, d2) {
    return d2.getUTCFullYear() - d1.getUTCFullYear();
  }

  diffInMonths(d1, d2) {
    return this.diffInYears(d1, d2) * 12 + (d2.getMonth() - d1.getMonth());
  }

  static get patterns() {
    return {
      dailyInterval: {
        test: (day, interval, di) => di.diffInDays(di.start || new Date(), day.date) % interval === 0
      },
      weeklyInterval: {
        test: (day, interval, di) => di.diffInWeeks(di.start || new Date(), day.date) % interval === 0
      },
      monthlyInterval: {
        test: (day, interval, di) => di.diffInMonths(di.start || new Date(), day.date) % interval === 0
      },
      yearlyInterval: {
        test: () => (day, interval, di) => di.diffInYears(di.start || new Date(), day.date) % interval === 0
      },
      days: {
        validate: days => isArrayLikeObject(days) ? days : [parseInt(days, 10)],
        test: (day, days) => days.includes(day.day) || days.includes(-day.dayFromEnd)
      },
      weekdays: {
        validate: weekdays => isArrayLikeObject(weekdays) ? weekdays : [parseInt(weekdays, 10)],
        test: (day, weekdays) => weekdays.includes(day.weekday)
      },
      ordinalWeekdays: {
        validate: ordinalWeekdays => Object.keys(ordinalWeekdays).reduce((obj, ck) => {
          const weekdays = ordinalWeekdays[ck];

          if (!weekdays) {
            return obj;
          }

          obj[ck] = isArrayLikeObject(weekdays) ? weekdays : [parseInt(weekdays, 10)];
          return obj;
        }, {}),
        test: (day, ordinalWeekdays) => Object.keys(ordinalWeekdays).map(key => parseInt(key, 10)).find(key => ordinalWeekdays[key].includes(day.weekday) && (key === day.weekdayOrdinal || key === -day.weekdayOrdinalFromEnd))
      },
      weekends: {
        validate: config => config,
        test: day => day.weekday === 1 || day.weekday === 7
      },
      workweek: {
        validate: config => config,
        test: day => day.weekday >= 2 && day.weekday <= 6
      },
      weeks: {
        validate: weeks => isArrayLikeObject(weeks) ? weeks : [parseInt(weeks, 10)],
        test: (day, weeks) => weeks.includes(day.week) || weeks.includes(-day.weekFromEnd)
      },
      months: {
        validate: months => isArrayLikeObject(months) ? months : [parseInt(months, 10)],
        test: (day, months) => months.includes(day.month)
      },
      years: {
        validate: years => isArrayLikeObject(years) ? years : [parseInt(years, 10)],
        test: (day, years) => years.includes(day.year)
      }
    };
  }

  static get patternProps() {
    return Object.keys(DateInfo.patterns).map(key => ({
      name: key,
      validate: DateInfo.patterns[key].validate
    }));
  }

  static testConfig(config, day, dateInfo) {
    if (typeof config === 'function') {
      return config(day);
    }

    if (isObject(config)) {
      return Object.keys(config).every(key => DateInfo.patterns[key].test(day, config[key], dateInfo));
    }

    return null;
  }

  iterateDatesInRange({
    start,
    end
  }, func) {
    if (!start || !end || typeof func !== 'function') {
      return null;
    }

    const state = {
      i: 0,
      date: start,
      day: this.locale.getDayFromDate(start),
      finished: false
    };
    let result = null;

    for (; !state.finished && state.date <= end; state.i++) {
      result = func(state);
      state.date = addDays(state.date, 1);
      state.day = this.locale.getDayFromDate(state.date);
    }

    return result;
  }

  intersectsDate(other) {
    const date = other.isDateInfo ? other : new DateInfo(other, {
      locale: this.locale
    });

    if (!this.shallowIntersectsDate(date)) {
      return null;
    }

    if (!this.on) {
      return this;
    }

    const range = this.findShallowIntersectingRange(this, date);
    let result = false;
    this.iterateDatesInRange(range, state => {
      if (this.matchesDay(state.day)) {
        result = result || date.matchesDay(state.day);
        state.finished = result;
      }
    });
    return result;
  }

  shallowIntersectsDate(other) {
    return this.dateShallowIntersectsDate(this, other.isDate ? other : new DateInfo(other, {
      locale: this.locale
    }));
  }

  dateShallowIntersectsDate(date1, date2) {
    if (date1.isDate) {
      return date2.isDate ? date1.dateTime === date2.dateTime : this.dateShallowIncludesDate(date2, date1);
    }

    if (date2.isDate) {
      return this.dateShallowIncludesDate(date1, date2);
    }

    if (date1.start && date2.end && date1.start > date2.end) {
      return false;
    }

    if (date1.end && date2.start && date1.end < date2.start) {
      return false;
    }

    return true;
  }

  includesDate(other) {
    const date = other.isDateInfo ? other : new DateInfo(other, {
      locale: this.locale
    });

    if (!this.shallowIncludesDate(date)) {
      return false;
    }

    if (!this.on) {
      return true;
    }

    const range = this.findShallowIntersectingRange(this, date);
    let result = true;
    this.iterateDatesInRange(range, state => {
      if (this.matchesDay(state.day)) {
        result = result && date.matchesDay(state.day);
        state.finished = !result;
      }
    });
    return result;
  }

  shallowIncludesDate(other) {
    return this.dateShallowIncludesDate(this, other.isDate ? other : new DateInfo(other, {
      locale: this.locale
    }));
  }

  dateShallowIncludesDate(date1, date2) {
    if (date1.isDate) {
      if (date2.isDate) {
        return date1.dateTime === date2.dateTime;
      }

      if (!date2.startTime || !date2.endTime) {
        return false;
      }

      return date1.dateTime === date2.startTime && date1.dateTime === date2.endTime;
    }

    if (date2.isDate) {
      if (date1.start && date2.date < date1.start) {
        return false;
      }

      if (date1.end && date2.date > date1.end) {
        return false;
      }

      return true;
    }

    if (date1.start && (!date2.start || date2.start < date1.start)) {
      return false;
    }

    if (date1.end && (!date2.end || date2.end > date1.end)) {
      return false;
    }

    return true;
  }

  includesDay(day) {
    if (!this.shallowIncludesDate(day.date)) {
      return null;
    }

    return this.matchesDay(day) ? this : null;
  }

  matchesDay(day) {
    if (!this.on) {
      return true;
    }

    if (this.on.and && !DateInfo.testConfig(this.on.and, day, this)) {
      return false;
    }

    if (this.on.or && !this.on.or.some(or => DateInfo.testConfig(or, day, this))) {
      return false;
    }

    return true;
  }

  toRange() {
    if (this.isDate) {
      return new DateInfo({
        start: this.date,
        end: this.date
      }, {
        locale: this.locale
      });
    }

    return new DateInfo({
      start: this.start,
      end: this.end
    }, {
      locale: this.locale
    });
  }

}

class Attribute {
  constructor({
    key,
    dates,
    excludeDates,
    excludeMode,
    pinPage
  }, locale) {
    this.key = key === undefined ? uuid() : key;
    this.pinPage = pinPage;

    if (dates) {
      this.dates = isArrayLikeObject(dates) ? dates : [dates];
    }

    this.hasDates = arrayHasItems(this.dates);

    if (excludeDates) {
      this.excludeDates = isArrayLikeObject(excludeDates) ? excludeDates : [excludeDates];
    }

    this.hasExcludeDates = arrayHasItems(this.excludeDates);
    this.excludeMode = excludeMode || 'intersects';
    this.dates = (this.hasDates && this.dates || this.hasExcludeDates && [{}] || []).map(d => d && (d instanceof DateInfo ? d : new DateInfo(d, {
      locale
    }))).filter(d => d);
    this.excludeDates = (this.hasExcludeDates && this.excludeDates || []).map(d => d && (d instanceof DateInfo ? d : new DateInfo(d, {
      locale
    }))).filter(d => d);
    this.isComplex = [dates].some(d => d.isComplex);
  }

  intersectsDate(date) {
    return !this.excludesDate(date) && (this.dates.find(d => d.intersectsDate(date)) || false);
  }

  includesDate(date) {
    return !this.excludesDate(date) && (this.dates.find(d => d.includesDate(date)) || false);
  }

  excludesDate(date) {
    return this.hasExcludeDates && this.excludeDates.find(ed => this.excludeMode === 'intersects' && ed.intersectsDate(date) || this.excludeMode === 'includes' && ed.includesDate(date));
  }

  includesDay(day) {
    return !this.excludesDay(day) && (this.dates.find(d => d.includesDay(day)) || false);
  }

  excludesDay(day) {
    return this.hasExcludeDates && this.excludeDates.find(ed => ed.includesDay(day));
  }

}

var script$5 = {
  name: 'Calendar',
  components: {
    CalendarPane
  },
  inject: ['state'],
  props: {
    activeAttribute: Object,
    disabledAttribute: Object
  },

  data() {
    return {
      pages: [],
      transitionName: '',
      isTransitioning: false,
      attribute: null,
      pinAttr: null
    };
  },

  computed: {
    locale() {
      return this.state.locale;
    },

    minPage() {
      return pageForDate(this.locale.toDate(this.state.minDate));
    },

    maxPage() {
      return pageForDate(this.locale.toDate(this.state.maxDate));
    },

    count() {
      return this.state.visibleColumnCount;
    }

  },
  watch: {
    count(count) {
      if (count > 1) {
        this.movePrev();
      } else if (this.state.model) {
        this.move(this.getPageForAttributes());
      } else {
        this.moveNext();
      }
    },

    activeAttribute() {
      this.refreshActiveAttribute();
      this.refreshAttributes();
    },

    pages() {
      this.refreshAttributes();
    },

    disabledAttribute() {
      this.refreshDisabledDays(this.pages);
    }

  },

  created() {
    this.refreshActiveAttribute();
    this.refreshAttributes();
    this.refreshPages();
  },

  methods: {
    refreshActiveAttribute() {
      if (!this.activeAttribute || !this.activeAttribute.dates) {
        this.attribute = null;
        this.pinAttr = null;
        return;
      }

      let pinAttr = null;
      const attribute = new Attribute(this.activeAttribute, this.locale);

      if (attribute && attribute.pinPage) {
        pinAttr = attribute;
      }

      this.attribute = attribute;
      this.pinAttr = pinAttr;
    },

    canMove(page) {
      return pageIsBetweenPages(page, this.minPage, this.maxPage);
    },

    movePrev() {
      this.move(-this.state.step);
    },

    moveNext() {
      this.move(this.state.step);
    },

    move(monthsOrPage) {
      const page = isNumber(monthsOrPage) ? addPages(this.pages[0], monthsOrPage) : monthsOrPage;
      this.refreshPages({
        page,
        position: 1
      });
    },

    refreshPages({
      page,
      position = 1
    } = {}) {
      let fromPage = null;

      if (pageIsValid(page)) {
        const pagesToAdd = position > 0 ? 1 - position : -(this.count + position);
        fromPage = addPages(page, pagesToAdd);
      } else {
        fromPage = this.getPageForAttributes();
      }

      fromPage = pageIsValid(fromPage) ? fromPage : pageForThisMonth();
      const toPage = addPages(fromPage, this.count - 1);

      if (pageIsBeforePage(fromPage, this.minPage)) {
        fromPage = this.minPage;
      } else if (pageIsAfterPage(toPage, this.maxPage)) {
        fromPage = addPages(this.maxPage, 1 - this.count);
      }

      const pages = [...Array(this.count).keys()].map(i => this.buildPage(addPages(fromPage, i), i));
      this.refreshDisabledDays(pages);
      this.transitionName = this.getPageTransition(this.pages[0], pages[0]);
      this.pages = pages;
      this.$emit('update:from-page', fromPage);
      this.$emit('update:to-page', toPage);
    },

    refreshDisabledDays(pages) {
      pages.reduce((prev, curr) => prev.concat(curr.days), []).forEach(day => {
        day.disabled = !!this.disabledAttribute && this.disabledAttribute.includesDay(day);
      });
    },

    getPageTransition(oldPage, newPage) {
      if (this.count > 1 || !pageIsValid(oldPage) || !pageIsValid(newPage)) {
        return 'fade';
      }

      const movePrev = pageIsBeforePage(newPage, oldPage);
      return movePrev ? 'slide-right' : 'slide-left';
    },

    getPageForAttributes() {
      const attr = this.pinAttr;

      if (attr && attr.hasDates) {
        let _attr$dates = _slicedToArray(attr.dates, 1),
            date = _attr$dates[0];

        date = date.start || date.date;
        return pageForDate(this.locale.toDate(date));
      }

      return null;
    },

    buildPage({
      month,
      year
    }, position) {
      const key = `${year.toString()}-${month.toString()}`;
      let page = this.pages.find(pg => pg.key === key);

      if (!page) {
        const date = new Date(year, month - 1, 15);
        const monthComps = this.locale.getMonthComps(month, year);
        const prevMonthComps = this.locale.getPrevMonthComps(month, year);
        const nextMonthComps = this.locale.getNextMonthComps(month, year);
        page = {
          key,
          month,
          year,
          title: this.locale.format(date, this.locale.masks.title),
          shortMonthLabel: this.locale.format(date, 'MMM'),
          monthLabel: this.locale.format(date, 'MMMM'),
          shortYearLabel: year.toString().substring(2),
          yearLabel: year.toString(),
          monthComps,
          prevMonthComps,
          nextMonthComps,
          canMove: pg => this.canMove(pg),
          move: pg => this.move(pg),
          movePrevMonth: () => this.move(prevMonthComps),
          moveNextMonth: () => this.move(nextMonthComps)
        };
        page.days = this.locale.getCalendarDays(page);
      }

      page.position = position;
      return page;
    },

    refreshAttributes() {
      if (this.pages.length === 0) {
        return;
      }

      this.pages.forEach(page => {
        page.days.forEach(day => {
          if (!this.attribute || !this.attribute.dates) {
            day.attribute = null;
            return;
          }

          const targetDate = this.attribute.includesDay(day);

          if (targetDate) {
            day.attribute = _objectSpread({}, this.attribute, {
              targetDate
            });
          } else {
            day.attribute = null;
          }
        });
      });
    }

  }
};

const __vue_script__$5 = script$5;

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-date-picker__calendar-panel",
    class: ["pendo-date-picker__calendar-panel--" + (_vm.count > 1 ? 'multiple' : 'single')]
  }, [_vm.$slots.above ? _c('div', {
    staticClass: "pendo-date-picker__calendar-panel-above"
  }, [_vm._t("above")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pendo-date-picker__calendar-panel-inner",
    class: {
      'is-transitioning': _vm.isTransitioning
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName
    },
    on: {
      "before-enter": function ($event) {
        _vm.isTransitioning = true;
      },
      "after-enter": function ($event) {
        _vm.isTransitioning = false;
      }
    }
  }, [_c('div', {
    key: _vm.pages[0].key,
    staticClass: "pendo-date-picker__calendar-grid"
  }, _vm._l(_vm.pages, function (page, index) {
    return _c('calendar-pane', _vm._g({
      key: page.key,
      ref: "pages",
      refInFor: true,
      attrs: {
        "page": page,
        "can-move": _vm.canMove,
        "min-page": _vm.minPage,
        "max-page": _vm.maxPage
      },
      on: {
        "move-prev": _vm.movePrev,
        "move-next": _vm.moveNext,
        "update:page": function ($event) {
          return _vm.refreshPages({
            page: $event,
            position: index + 1
          });
        }
      }
    }, _vm.$listeners));
  }), 1)])], 1)]);
};

var __vue_staticRenderFns__$5 = [];
const __vue_inject_styles__$5 = undefined;
const __vue_scope_id__$5 = undefined;
const __vue_is_functional_template__$5 = false;

function __vue_normalize__$5(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "calendar.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var Calendar = __vue_normalize__$5({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5);

class SinglePicker {
  constructor({
    format,
    parse
  }) {
    Object.assign(this, {
      format,
      parse
    });
  }

  hasValue(value) {
    if (isDate(value)) {
      return true;
    }

    if (new Date(value).getTime() > 0) {
      return true;
    }

    return false;
  }

  normalize(value) {
    return value && new Date(value);
  }

  valuesAreEqual(a, b) {
    return datesAreEqual(a, b);
  }

  formatValue(value) {
    return this.hasValue(value) ? this.format(value) : '';
  }

  parseValue(text) {
    const value = this.parse(text);
    return isDate(value) ? value : null;
  }

  filterDisabled({
    value,
    isRequired,
    disabled,
    fallbackValue
  }) {
    if (!this.hasValue(value) && isRequired) {
      return fallbackValue;
    }

    if (this.hasValue(value) && disabled && disabled.intersectsDate(value)) {
      return null;
    }

    return value;
  }

  getPageRange(value) {
    if (!this.hasValue(value)) {
      return null;
    }

    const from = pageForDate(value);
    return {
      from,
      to: from
    };
  }

  parseShortcutValue(value) {
    value = isDate(value) ? value : addDays(new Date(), value);
    value.setHours(0, 0, 0, 0);
    return this.normalize(value);
  }

  handleShortcutSelect(shortcut, picker) {
    if (picker.dateIsValid(shortcut.value)) {
      picker.model = shortcut.value;
    }
  }

  handleDayClick(day, picker) {
    if (!picker.dateIsValid(day.date)) {
      return;
    }

    if (this.valuesAreEqual(day.date, picker.model)) {
      if (!picker.isRequired) {
        picker.model = null;
        picker.$emit('select-date', {
          value: null
        });
      } else {
        picker.togglePopover();
      }
    } else {
      picker.model = day.date;
      picker.$emit('select-date', {
        value: day.date
      });
    }
  }

  handleDayMouseEnter() {
    return;
  }

}

class MultiplePicker {
  constructor({
    format,
    parse
  }) {
    Object.assign(this, {
      format,
      parse
    });
  }

  hasValue(value) {
    return arrayHasItems(value);
  }

  formatValue(value) {
    if (this.hasValue(value)) {
      return value.map(val => this.format(val)).join(', ');
    }

    return '';
  }

  parseValue(text) {
    if (!isString(text)) {
      return [];
    }

    return text.split(',').map(section => this.parse(section)).filter(date => isDate(date));
  }

  normalize(value) {
    if (!this.hasValue(value)) {
      return [];
    }

    return [...new Set(value)].sort((a, b) => a.getTime() - b.getTime());
  }

  filterDisabled({
    value,
    isRequired,
    disabled,
    fallbackValue
  }) {
    if (!this.hasValue(value)) {
      return [];
    }

    if (!disabled) {
      return value;
    }

    const newValue = value.filter(date => !disabled.intersectsDate(date));

    if (!this.hasValue(newValue) && isRequired) {
      return fallbackValue;
    }

    return newValue;
  }

  valuesAreEqual(valueA, valueB) {
    const aHasItems = this.hasValue(valueA);
    const bHasItems = this.hasValue(valueB);

    if (!aHasItems && !bHasItems) {
      return true;
    }

    if (aHasItems !== bHasItems || valueA.length !== valueB.length) {
      return false;
    }

    return valueA.some(val => !valueB.includes(val));
  }

  getPageRange(value) {
    if (!this.hasValue(value)) {
      return null;
    }

    const from = pageForDate(value[0]);
    const to = getMaxPage(pageForDate([].concat(value).pop()), addPages(from, 1));
    return {
      from,
      to
    };
  }

  handleDayClick(day, picker) {
    if (!picker.dateIsValid(day.date)) {
      return;
    }

    let value = [];

    if (!this.hasValue(picker.model)) {
      value = [day.date];
    } else if (picker.model.some(date => date.getTime() === day.dateTime)) {
      value = picker.model.filter(date => !datesAreEqual(date, day.date));

      if (!this.hasValue(value) && picker.isRequired) {
        value = [day.date];
      }
    } else {
      value = [...picker.model, day.date];
    }

    picker.model = this.normalize(value);
  }

  handleDayMouseEnter() {
    return;
  }

}

class RangePicker {
  constructor({
    locale,
    format,
    parse
  }) {
    Object.assign(this, {
      locale,
      format,
      parse
    });
  }

  hasValue(value) {
    return isPlainObject(value) && isDate(value.start) && isDate(value.end);
  }

  normalize(value) {
    if (!this.hasValue(value)) {
      return null;
    }

    const _DateInfo = new DateInfo({
      start: new Date(value.start),
      end: new Date(value.end)
    }, {
      locale: this.locale
    }),
          start = _DateInfo.start,
          end = _DateInfo.end;

    return {
      start,
      end
    };
  }

  formatValue(value) {
    const nValue = this.normalize(value);

    if (!nValue) {
      return '';
    }

    const start = nValue.start,
          end = nValue.end;
    const startText = this.format(start);
    const endText = this.format(end);

    if (!startText || !endText) {
      return '';
    }

    return `${startText} - ${endText}`;
  }

  parseValue(text) {
    let start, end;
    const dateTexts = text.split('-').map(s => s.trim());

    if (dateTexts.length >= 2) {
      start = this.parse(dateTexts[0]);
      end = this.parse(dateTexts[1]);
    }

    return start && end ? this.normalize({
      start,
      end
    }) : null;
  }

  filterDisabled({
    value,
    isRequired,
    disabled,
    fallbackValue
  }) {
    let newValue = isRequired ? fallbackValue : null;

    if (this.hasValue(value) && (!disabled || !disabled.intersectsDate(value))) {
      newValue = value;
    }

    return newValue;
  }

  valuesAreEqual(a, b) {
    const aHasValue = this.hasValue(a);
    const bHasValue = this.hasValue(b);

    if (!aHasValue && !bHasValue) {
      return true;
    }

    if (aHasValue !== bHasValue) {
      return false;
    }

    return datesAreEqual(a.start, b.start) && datesAreEqual(a.end, b.end);
  }

  getPageRange(value) {
    if (!this.hasValue(value)) {
      return null;
    }

    const from = pageForDate(value.start);
    const to = getMaxPage(pageForDate(value.end), addPages(from, 1));
    return {
      from,
      to
    };
  }

  parseShortcutValue(value) {
    if (isDate(value.start) && isDate(value.end)) {
      return this.normalize(value);
    }

    return this.normalize({
      start: addDays(new Date(), value.start),
      end: addDays(new Date(), value.end)
    });
  }

  handleDayClick(day, picker) {
    const dateTime = day.dateTime;

    if (!picker.dragValue) {
      const newDragValue = {
        start: new Date(dateTime),
        end: new Date(dateTime)
      };

      if (picker.dateIsValid(newDragValue)) {
        picker.dragValue = newDragValue;
      }
    } else {
      const value = this.normalize({
        start: new Date(picker.dragValue.start.getTime()),
        end: new Date(dateTime)
      });

      if (picker.dateIsValid(value)) {
        picker.dragValue = null;
        picker.model = value;
        picker.$emit('select-date', {
          value
        });
      }
    }
  }

  handleShortcutSelect(shortcut, picker) {
    if (picker.dateIsValid(shortcut.value)) {
      picker.dragValue = null;
      picker.model = shortcut.value;
    }
  }

  handleDayMouseEnter(day, picker) {
    const dateTime = day.dateTime;

    if (picker.dragValue) {
      const newDragValue = {
        start: new Date(picker.dragValue.start.getTime()),
        end: new Date(dateTime)
      };

      if (picker.dateIsValid(newDragValue)) {
        picker.dragValue = newDragValue;
      }
    }
  }

}

const locales = {
  ar: {
    dow: 7,
    L: 'D/\u200FM/\u200FYYYY'
  },
  bg: {
    dow: 2,
    L: 'D.MM.YYYY'
  },
  ca: {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  'zh-CN': {
    dow: 2,
    L: 'YYYY/MM/DD'
  },
  'zh-TW': {
    dow: 1,
    L: 'YYYY/MM/DD'
  },
  hr: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  cs: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  da: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  nl: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  'en-US': {
    dow: 1,
    L: 'MM/DD/YYYY'
  },
  'en-AU': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  'en-CA': {
    dow: 1,
    L: 'YYYY-MM-DD'
  },
  'en-GB': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  'en-IE': {
    dow: 2,
    L: 'DD-MM-YYYY'
  },
  'en-NZ': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  eo: {
    dow: 2,
    L: 'YYYY-MM-DD'
  },
  fi: {
    dow: 2,
    L: 'Do MMMM[ta] YYYY'
  },
  fr: {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  'fr-CA': {
    dow: 1,
    L: 'YYYY-MM-DD'
  },
  'fr-CH': {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  de: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  id: {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  it: {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  ja: {
    dow: 1,
    L: 'YYYY年M月D日'
  },
  ko: {
    dow: 1,
    L: 'YYYY.MM.DD'
  },
  mk: {
    dow: 2,
    L: 'D.MM.YYYY'
  },
  pl: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  pt: {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  ro: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  ru: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  sk: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  es: {
    dow: 1,
    L: 'DD/MM/YYYY'
  },
  sv: {
    dow: 2,
    L: 'YYYY-MM-DD'
  },
  th: {
    dow: 1,
    L: 'DD/MM/YYYY'
  },
  tr: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  uk: {
    dow: 2,
    L: 'DD.MM.YYYY'
  }
};
locales.en = locales['en-US'];
locales.zh = locales['zh-CN'];
Object.entries(locales).forEach(([id, {
  dow,
  L
}]) => {
  locales[id] = {
    firstDayOfWeek: dow,
    masks: {
      L
    }
  };
});

const DEFAULT_MASKS = {
  title: 'MMMM YYYY',
  weekdays: 'W',
  months: 'MMM',
  input: ['MMM D, YYYY', 'L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
  data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD']
};
var script$6 = {
  name: 'PendoDatePicker',
  components: {
    Calendar,
    PendoIcon,
    PendoLoadingIndicator,
    PickerPopover,
    Shortcuts
  },

  provide() {
    return {
      state: this
    };
  },

  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: null,
      required: true
    },
    type: {
      type: String,
      default: 'single'
    },
    loading: {
      type: Boolean,
      default: false
    },
    isRequired: Boolean,
    disabledDates: {
      type: null,
      default: null
    },
    availableDates: {
      type: null,
      default: null
    },
    updateOnInput: {
      type: Boolean,
      default: false
    },
    updateOnDrag: {
      type: Boolean,
      default: false
    },
    popover: {
      type: Object,
      default: () => ({})
    },
    popperOptions: {
      type: Object,
      default: () => ({})
    },
    labels: {
      type: Object,
      default: () => ({})
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    minTriggerWidth: {
      type: [String, Number],
      default: 160
    },
    maxTriggerWidth: {
      type: [String, Number],
      default: 400
    },
    maxMenuWidth: {
      type: [String, Number],
      default: 400
    },
    minMenuWidth: {
      type: [String, Number],
      default: 160
    },
    maxMenuHeight: {
      type: [String, Number],
      default: 300
    },
    triggerSize: {
      type: String,
      default: 'medium',
      validator: triggerSize => ['mini', 'small', 'medium'].includes(triggerSize)
    },
    firstDayOfWeek: {
      type: Number,
      default: 1
    },
    masks: {
      type: Object,
      default: null
    },
    localeCode: {
      type: String,
      default: 'en-US'
    },
    columns: {
      type: Number,
      default: 1
    },
    step: {
      type: Number,
      default: 1
    },
    fromDate: Date,
    toDate: Date,
    minDate: {
      type: null,
      default: null
    },
    maxDate: {
      type: null,
      default: null
    },
    shortcuts: {
      type: [Boolean, Array],
      default: () => [{
        label: 'Today',
        value: {
          start: 0,
          end: 0
        }
      }, {
        label: 'Yesterday',
        value: {
          start: -1,
          end: -1
        }
      }, {
        label: 'Last 7 Days',
        value: {
          start: -1,
          end: -7
        }
      }, {
        label: 'Last 30 Days',
        value: {
          start: -1,
          end: -30
        }
      }, {
        label: 'Last 90 Days',
        value: {
          start: -1,
          end: -90
        }
      }]
    },
    placeholder: {
      type: String,
      default: 'Select Date'
    },
    editable: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dragValue: null,
      inputValue: null,
      inputFocused: false,
      focused: false,
      isPopoverVisible: false,
      disableFormatInput: false,
      disablePopoverHide: false,
      isCalendarVisible: false,
      visibleColumnCount: this.columns,
      twoColumnBreakpoint: null
    };
  },

  computed: {
    popoverOptions() {
      let behavior = [];

      if (this.popperOptions && this.popperOptions.placement) {
        if (this.popperOptions.placement.includes('-end')) {
          behavior = ['bottom-end', 'top-end'];
        } else {
          behavior = ['bottom-start', 'top-start'];
        }
      }

      return _objectSpread({}, this.popperOptions, {
        modifiers: {
          hide: {
            enabled: false
          },
          preventOverflow: {
            enabled: false
          },
          flip: {
            enabled: true,
            behavior,
            fn: this.flipPopperVariations
          },
          arrow: {
            enabled: false
          },
          applyStyle: {
            enabled: true,
            order: 900,
            fn: this.applyPopperStyle
          }
        }
      });
    },

    model: {
      get() {
        return this.picker.normalize(this.value);
      },

      set(val) {
        this.$emit('change', val);

        if (!this.disableFormatInput) {
          this.formatInput();
        }

        if (this.type !== 'multiple' && this.isPopoverVisible && !this.disablePopoverHide) {
          this.hidePopover();
        }

        this.disableFormatInput = false;
        this.disablePopoverHide = false;
      }

    },

    showShortcuts() {
      if (this.type !== 'range') {
        return !!this.$options.propsData.shortcuts;
      }

      return !!this.shortcuts;
    },

    shortcutOptions() {
      if (!this.showShortcuts) {
        return null;
      }

      const shortcuts = this.shortcuts.map(shortcut => {
        const newValue = this.picker.parseShortcutValue(shortcut.value);
        const selected = this.picker.valuesAreEqual(this.model, newValue);
        return _objectSpread({}, shortcut, {
          value: newValue,
          disabled: !this.dateIsValid(newValue),
          selected: !this.isCalendarVisible && selected
        });
      });
      const isCustomRangeSelected = shortcuts.every(option => !option.selected);
      shortcuts.push({
        label: 'Custom Range',
        value: 'custom',
        disabled: false,
        selected: isCustomRangeSelected || this.isCalendarVisible
      });
      return shortcuts;
    },

    locale() {
      const detLocale = new Intl.DateTimeFormat().resolvedOptions().locale;
      let id = this.localeCode || detLocale;
      id = [id, id.substring(0, 2)].find(i => locales[i]) || detLocale;
      const config = {
        id,
        firstDayOfWeek: this.firstDayOfWeek || locales[id].firstDayOfWeek,
        masks: _objectSpread({}, locales[id].masks, DEFAULT_MASKS, this.masks)
      };
      return new Locale(config);
    },

    inputMasks() {
      const inputFormat = this.locale.masks.input;
      return isArrayLikeObject(inputFormat) && inputFormat || [inputFormat];
    },

    selectAttribute() {
      if (!this.picker.hasValue(this.model)) {
        return null;
      }

      return {
        key: 'select',
        dates: this.model,
        pinPage: true
      };
    },

    dragAttribute() {
      if (this.type !== 'range' || !this.picker.hasValue(this.dragValue)) {
        return null;
      }

      return {
        key: 'drag',
        dates: this.dragValue
      };
    },

    disabledAttribute() {
      const dates = [];

      if (this.disabledDates) {
        if (isArrayLikeObject(this.disabledDates)) {
          dates.push(...this.disabledDates);
        } else {
          dates.push(this.disabledDates);
        }
      }

      const minDate = this.locale.toDate(this.minDate);
      const maxDate = this.locale.toDate(this.maxDate);

      if (minDate) {
        dates.push({
          start: null,
          end: addDays(minDate, -1)
        });
      }

      if (maxDate) {
        dates.push({
          start: addDays(maxDate, 1),
          end: null
        });
      }

      return new Attribute({
        key: 'disabled',
        dates,
        excludeDates: this.availableDates,
        excludeMode: 'includes'
      }, this.locale);
    },

    activeAttribute() {
      if (this.dragAttribute) {
        return this.dragAttribute;
      }

      if (this.selectAttribute) {
        return this.selectAttribute;
      }

      return null;
    },

    picker() {
      const opts = {
        locale: this.locale,
        format: date => this.locale.format(date, this.inputMasks[0]),
        parse: str => this.locale.parse(str, this.inputMasks)
      };

      switch (this.type) {
        case 'multiple':
          return new MultiplePicker(opts);

        case 'range':
          return new RangePicker(opts);

        case 'date':
        case 'day':
        default:
          return new SinglePicker(opts);
      }
    }

  },
  watch: {
    model() {
      this.formatInput();
    },

    type() {
      this.inputValue = null;
    },

    dragValue(val) {
      if (this.updateOnDrag) {
        this.formatInput();
      }

      this.$emit('drag', this.picker.normalize(val));
    },

    minTriggerWidth() {
      setStyles(this.$refs.trigger, {
        minWidth: this.fullWidth ? '100%' : this.minTriggerWidth
      });
    },

    maxTriggerWidth() {
      setStyles(this.$refs.trigger, {
        maxWidth: this.maxTriggerWidth
      });
    }

  },

  created() {
    this.formatInput();
  },

  mounted() {
    setStyles(this.$refs.trigger, {
      minWidth: this.fullWidth ? '100%' : this.minTriggerWidth,
      maxWidth: this.maxTriggerWidth
    });
  },

  methods: {
    handleShortcutSelect(option) {
      if (option.value === 'custom') {
        this.isCalendarVisible = true;
        return;
      }

      this.$emit('select-shortcut', option);
      this.disableFormatInput = true;
      this.picker.handleShortcutSelect(option, this);
      this.inputValue = option.label;
      this.isPopoverVisible = false;
      this.isCalendarVisible = false;
    },

    dateIsValid(date) {
      return !!this.disabledAttribute && !this.disabledAttribute.intersectsDate(date);
    },

    handleDayClick(day) {
      this.picker.handleDayClick(day, this);
      this.$emit('dayclick', day);
    },

    handleDayFocusIn(day) {
      if (day.el) {
        day.el.blur();
      }

      this.$emit('dayfocusin', day);
    },

    handleDayMouseEnter(day) {
      this.picker.handleDayMouseEnter(day, this);
      this.$emit('daymouseenter', day);
    },

    updateInputValue({
      target
    }) {
      this.inputValue = target.value;

      if (this.updateOnInput) {
        this.updateValue(this.inputValue, {
          formatInput: false,
          hidePopover: false
        });
      }
    },

    handleInputBlur() {
      this.inputFocused = false;
    },

    handleInputFocus() {
      this.inputFocused = true;
      this.showPopover();
    },

    handleInputChange() {
      this.updateValue(this.inputValue, {
        formatInput: true,
        hidePopover: false
      });
    },

    handleInputEsc() {
      this.updateValue(this.model, {
        formatInput: true,
        hidePopover: true
      });
    },

    updateValue(value, {
      formatInput,
      hidePopover
    } = {}) {
      this.inputValue = isString(value) ? value : this.inputValue;
      const userValue = isString(value) ? this.picker.parseValue(value) : value;
      const validatedValue = this.picker.filterDisabled({
        value: this.picker.normalize(userValue),
        isRequired: this.isRequired,
        disabled: this.disabledAttribute,
        fallbackValue: this.model
      });

      if (this.picker.valuesAreEqual(this.model, validatedValue)) {
        if (formatInput) {
          this.formatInput();
        }

        if (hidePopover) {
          this.hidePopover();
        }
      } else {
        this.disableFormatInput = !formatInput;
        this.disablePopoverHide = !hidePopover;
        this.model = validatedValue;
      }
    },

    formatInput() {
      this.$nextTick(() => {
        if (this.picker.hasValue(this.dragValue)) {
          this.inputValue = this.picker.formatValue(this.dragValue);
          return;
        }

        const matchingShortcut = this.showShortcuts && this.shortcutOptions.filter(shortcut => shortcut.value !== 'custom').find(shortcut => this.picker.valuesAreEqual(shortcut.value, this.model));

        if (matchingShortcut) {
          this.inputValue = matchingShortcut.label;
          return;
        }

        this.inputValue = this.picker.formatValue(this.model);
      });
    },

    togglePopover() {
      if (this.isPopoverVisible) {
        if (this.editable && this.inputFocused) {
          return;
        }

        this.hidePopover();
      } else {
        this.showPopover();
      }
    },

    hidePopover() {
      this.dragValue = null;
      this.isPopoverVisible = false;
      this.isCalendarVisible = false;
    },

    showPopover() {
      if (this.showShortcuts) {
        this.isCalendarVisible = !!this.shortcutOptions.find(shortcut => shortcut.value === 'custom').selected;
      }

      this.isPopoverVisible = true;
    },

    applyPopperStyle(data) {
      if (!this.fullWidth) {
        data.styles.minWidth = Math.max(this.minMenuWidth, data.offsets.reference.width);
      }

      setStyles(data.instance.popper, data.styles);
      setAttributes(data.instance.popper, data.attributes);
      return data;
    },

    flipPopperVariations(data) {
      const offsets = data.offsets;
      const popper = offsets.popper,
            reference = offsets.reference;

      if (this.type === 'range' && this.columns > 1 && this.visibleColumnCount === 1 && this.twoColumnBreakpoint < window.innerWidth) {
        this.twoColumnBreakpoint = null;
        this.visibleColumnCount++;
        return data;
      }

      const elementLocation = this.$el.getBoundingClientRect();
      const elementLocationBottom = elementLocation.bottom;

      if (elementLocationBottom + this.maxMenuHeight > window.innerHeight) {
        data.instance.options.placement = 'top-start';
        return data;
      }

      if (reference.left + popper.width < window.innerWidth) {
        data.instance.options.placement = data.flipped ? 'top-start' : 'bottom-start';
        return data;
      }

      if (this.type === 'range' && this.visibleColumnCount > 1) {
        this.twoColumnBreakpoint = reference.left + popper.width;
        this.visibleColumnCount--;
        return data;
      }

      data.instance.options.placement = data.flipped ? 'top-end' : 'bottom-end';
      data.instance.scheduleUpdate();
      return data;
    }

  }
};

const __vue_script__$6 = script$6;

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-date-picker",
    class: {
      'is-active': _vm.isPopoverVisible,
      'is-open': _vm.isPopoverVisible,
      'has-inline-label': !!_vm.labels.left || !!_vm.labels.right,
      'is-error': _vm.invalid
    }
  }, [_vm.labels.top || _vm.labels.left || !!_vm.$slots.topLabel ? _c('div', {
    staticClass: "pendo-date-picker__label pendo-date-picker__label--top"
  }, [_vm._t("topLabel", [_vm._v("\n            " + _vm._s(_vm.labels.top || _vm.labels.left) + "\n        ")])], 2) : _vm._e(), _vm._v(" "), _c('picker-popover', {
    attrs: {
      "is-open": _vm.isPopoverVisible,
      "append-to-body": _vm.appendToBody,
      "popper-options": _vm.popoverOptions,
      "min-width": _vm.minMenuWidth,
      "full-width": _vm.fullWidth
    },
    on: {
      "click-outside": _vm.hidePopover,
      "hide": _vm.hidePopover
    },
    scopedSlots: _vm._u([{
      key: "popper",
      fn: function () {
        return [_c('div', {
          staticClass: "pendo-date-picker__panel",
          class: ["pendo-date-picker--" + _vm.type, {
            'has-shortcuts': _vm.showShortcuts
          }]
        }, [_vm.showShortcuts ? _c('shortcuts', {
          ref: "shortcuts",
          attrs: {
            "options": _vm.shortcutOptions
          },
          on: {
            "select": _vm.handleShortcutSelect
          },
          scopedSlots: _vm._u([{
            key: "shortcut",
            fn: function (props) {
              return [_vm._t("shortcut", null, null, props)];
            }
          }], null, true)
        }) : _vm._e(), _vm._v(" "), _vm.isCalendarVisible || !_vm.showShortcuts ? _c('calendar', _vm._g({
          ref: "calendar",
          attrs: {
            "active-attribute": _vm.activeAttribute,
            "disabled-attribute": _vm.disabledAttribute
          },
          on: {
            "dayclick": _vm.handleDayClick,
            "dayfocusin": _vm.handleDayFocusIn,
            "daymouseenter": _vm.handleDayMouseEnter
          },
          scopedSlots: _vm._u([{
            key: "above",
            fn: function () {
              return [_vm._t("above")];
            },
            proxy: true
          }], null, true)
        }, _vm.$listeners)) : _vm._e()], 1)];
      },
      proxy: true
    }])
  }, [_c('button', {
    ref: "trigger",
    staticClass: "pendo-date-picker__trigger",
    class: ["pendo-date-picker__trigger--" + _vm.triggerSize, {
      'is-active': _vm.focused || _vm.isPopoverVisible,
      'is-open': _vm.isPopoverVisible,
      'is-disabled': _vm.disabled || _vm.loading,
      'is-error': _vm.invalid
    }],
    attrs: {
      "type": "button",
      "role": "button",
      "aria-label": _vm.isPopoverVisible ? 'close picker' : 'open picker',
      "aria-haspopup": ""
    },
    on: {
      "click": _vm.togglePopover,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        return _vm.hidePopover($event);
      },
      "focus": function ($event) {
        _vm.focused = true;
      },
      "blur": function ($event) {
        _vm.focused = false;
      }
    }
  }, [_c('div', {
    staticClass: "pendo-date-picker__prefix"
  }, [_vm._t("prefix", [_c('pendo-icon', {
    attrs: {
      "type": "calendar",
      "size": "14"
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "pendo-date-picker__value"
  }, [_vm.editable ? _c('input', {
    ref: "input",
    staticClass: "pendo-date-picker__input",
    attrs: {
      "readonly": !_vm.editable,
      "name": "input",
      "autocapitalize": "none",
      "autocorrect": "off",
      "autocomplete": "off",
      "spellcheck": "false",
      "aria-autocomplete": "list",
      "placeholder": _vm.placeholder,
      "type": "text"
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "input": _vm.updateInputValue,
      "change": _vm.handleInputChange,
      "focus": function ($event) {
        $event.stopPropagation();
        return _vm.handleInputFocus($event);
      },
      "blur": _vm.handleInputBlur,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        return _vm.handleInputEsc($event);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("value", [!_vm.editable ? _c('span', {
    staticClass: "pendo-date-picker__input-value",
    domProps: {
      "textContent": _vm._s(_vm.inputValue || _vm.placeholder)
    }
  }) : _vm._e()], {
    "value": _vm.inputValue
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pendo-date-picker__suffix",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.togglePopover($event);
      }
    }
  }, [_vm._t("suffix", [!_vm.loading ? _c('pendo-icon', {
    staticClass: "pendo-date-picker__caret",
    class: {
      'is-active': _vm.isPopoverVisible
    },
    attrs: {
      "type": "chevron-down",
      "size": "14"
    }
  }) : _vm._e(), _vm._v(" "), _vm.loading ? _c('pendo-loading-indicator', {
    attrs: {
      "type": "material",
      "size": "small"
    }
  }) : _vm._e()])], 2)])]), _vm._v(" "), _vm.labels.bottom || _vm.labels.right || !!_vm.$slots.bottomLabel ? _c('div', {
    staticClass: "pendo-date-picker__label pendo-date-picker__label--bottom"
  }, [_vm._t("bottomLabel", [_vm._v("\n            " + _vm._s(_vm.labels.bottom || _vm.labels.right) + "\n        ")])], 2) : _vm._e()], 1);
};

var __vue_staticRenderFns__$6 = [];
const __vue_inject_styles__$6 = undefined;
const __vue_scope_id__$6 = undefined;
const __vue_is_functional_template__$6 = false;

function __vue_normalize__$6(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-date-picker.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoDatePicker = __vue_normalize__$6({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6);

export default pendoDatePicker;
